export default __webpack_public_path__ + "static/media/ApiIcon.3214338a.svg";